import type { ProductRecommendationItem } from './types';

export const normalizeRecommendations = (value: unknown): Array<ProductRecommendationItem> => {
  if (!Array.isArray(value)) {
    return [];
  }

  return value.map(item => {
    const recommendation = (item ?? {}) as Partial<ProductRecommendationItem>;
    return {
      product_type: recommendation.product_type ?? '',
      description: recommendation.description ?? '',
      mapped_lk_styles: Array.isArray(recommendation.mapped_lk_styles)
        ? recommendation.mapped_lk_styles.map(value => String(value))
        : [],
      mapped_product_images:
        recommendation.mapped_product_images &&
        typeof recommendation.mapped_product_images === 'object'
          ? recommendation.mapped_product_images
          : {},
    };
  });
};

export const areRecommendationsEqual = (
  left: Array<ProductRecommendationItem>,
  right: Array<ProductRecommendationItem>,
) => JSON.stringify(left) === JSON.stringify(right);

export const labelNode = (text: string) => (
  <span className="text-xs font-medium tracking-wide text-foreground">{text}</span>
);

export const SectionHeading = ({ title }: { title: string }) => (
  <h3 className="m-0 text-xs font-semibold tracking-wide text-muted-foreground uppercase">
    {title}
  </h3>
);
